<div *ngIf="urlConditionMet; else logged_in_content">
  <router-outlet></router-outlet>
</div>

<ng-template #logged_in_content>
  <div class="main" id="main" [class.is_logged_on]="isAuthenticated" [class.is_logged_off]="!isAuthenticated">
    <left-navigation
      [isSideBarOpen]="isSideBarOpen"
      *ngIf="isAuthenticated && isNavPropertiesEnabled"
    ></left-navigation>

    <div [class]="top_menu_bar" [ngClass]="{ active: isSideBarOpen === true,'top_menu_bar_0m': !showNavigation}">
      <div class="tab-content">
        <top-banner
          [isSideBarOpen]="isSideBarOpen"
          (isSideBarOpenEvent)="isSideBarOpenEvent($event)"
          *ngIf="isAuthenticated && isNavPropertiesEnabled && showNavigation"
        ></top-banner>
        <div id="overview" class="tab-pane active">
          <div class="content">
            <div class="content-wrapper">
              <router-outlet></router-outlet>

              <!---->
              <background-file-uploader></background-file-uploader>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer [class.active]="isSideBarOpen && isNavPropertiesEnabled"  [class.noLeftMargin]="isFooterNoLeftMargin"></footer>
</ng-template>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-spin-clockwise"
  [fullScreen]="true"
></ngx-spinner>
